import { Link } from "react-router-dom";
import { Checkbox, Icon } from "../../components";
import * as documateLabel from '../shared/util/docuMateLabel';
import DocuMateIndexing from "./DocuMateIndexing";
import DocumentPreviewIcon from "../shared/components/DocumentPreviewIcon";
import { getListOfFolderDocCountToDoList, getListOfGroup, getListOfGroupDocCountToDoList, getUsersToDoList, searchDocToDoList, updateDocStatusToDoList, getUsersRecycleBin, getListOfFolderByGroupId, toggleDocumentLock, hardLockDocument, getMyLockedDocuments, releaseSoftLockDocuments} from "../services/DocuMateAPI";
import { GroupListDocCountResponseDto } from "../model/GroupListDocCountResponseDto";
import { DocQueueGroupListResponseDto } from "../model/DocQueueGroupListResponseDto";
import { FolderListDocCountResponseDto } from "../model/FolderListDocCountResponseDto";
import { CommonDataDto } from "../../customer/model/CommonDataDto";
import * as constant from '../../shared/util/constant';
import { GetDocumentInfoOnSearchResponseDto } from "../model/GetDocumentInfoOnSearchResponseDto";
import { DocumentStatusResponseDto } from "../model/DocumentStatusResponseDto";
import { CommonUtility } from "../../Services/CommonUtility";
import * as docuMateConstant from '../shared/util/docuMateConstant';
import { GetFolderListByGroupIdQuery } from "../model/GetFolderListByGroupIdQuery";
import { LockDocumentsResponseDto } from "../model/LockDocumentsResponseDto";

class DocuMateTodoListService {
    static async getTodoList() {
        // const todoList = await getTodoList();
        // return todoList;
    }

    public getTodoListGridColumns(onDeleteDocument: (id: any) => void, onHardLockDocument: (id: any) => void, handleOnHoldChange: (id: any) => void, handleDocumentClick: (id: any) => void, handleToggleLock: (id: string, isCurrentlyLocked: boolean) => void) {
        let gridColumns = [
            {
                Header: <Icon icon="lock" className='grd-header-icon' />,
                accessor: 'lockIcon',
                Cell: row => {
                    const data = row.row?.original;
                    return (
                        <div className='todoList-lock-icon-column'>
                        {
                            (() => {
                                switch (true) {
                                    case data?.isHardLocked:
                                        return <Icon title={data?.assignedTo} icon="userPen" className='grd-cell-icon--working' />;
                                    case data?.onHold:
                                        return <Icon title={documateLabel.TODO_LIST_ON_HOLD} icon="lock-open" className='grd-cell-icon--disabled' />;
                                    case data?.isSoftLock:
                                        return <Icon title={data?.assignedTo} icon="lock" className='grd-cell-icon--lock' onClick={() => { handleToggleLock(data?.id, true); }} />;
                                    default:
                                        return <Icon icon="lock-open" className='grd-cell-icon--lock-open' onClick={() => { handleToggleLock(data?.id, false); }} />;
                                }
                            })()
                            }
                        </div>
                    );
                },
                width: 50,
                sortType: 'string',
                disableSortBy: true,
                disableFilters: true
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.fileName,
                accessor: 'scanId',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours)
                            ? `todoList-grd-cell TODoGridCellBackgroundColor ${(row.row?.original?.isPickedForLock) ? 'todoList-row-locked-by-me' : ''}`
                            : `todoList-grd-cell ${( row.row?.original?.isPickedForLock)? 'todoList-row-locked-by-me' : ''}`}>
                            <Link
                                to={{
                                    pathname: '',
                                    state: { scanId: row.row?.original?.scanId, id: row.row?.original?.id, docStatus: row.row?.original?.isWorking ? 'working' : row.row?.original?.isHardLocked ? 'hardLocked' : row.row?.original?.canHardLock ? 'softLocked' : '' }
                                }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    handleDocumentClick(row.row?.original?.id)
                                }
                                }
                                className="text-start text-decoration-none scanIdStyle"
                                title="row.value"                                
                            ><span title={row.row?.original?.scanId}>{row.row?.original?.scanId}</span></Link>
                            <DocumentPreviewIcon docFileId={row.row?.original?.docFileId} scanId={row.row?.original?.scanId} />
                        </div>
                    )
                },
                width: 350,
                sortType: 'string'
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.onHold,
                accessor: 'onHold',
                //type: 'CheckBox',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell--checkbox'>
                            <Checkbox
                                id={`onHoldCheckbox-${row.row?.original?.id}`}
                                disabled={true}
                                label={""}
                                checked={row.row.original?.onHold ? true : false}
                                onChange={(event) => handleOnHoldChange(row.row?.original?.id)}
                            />
                        </div>
                    )
                },
                sortType: 'bool',
                width: 75
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.docDescription,
                accessor: 'docDescription',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours) ? "todoList-grd-cell TODoGridCellBackgroundColor" : "todoList-grd-cell"}>
                            <span title={row.row?.original?.docDescription}>{row.row?.original?.docDescription}</span>
                        </div>
                    )
                },
                width: 295
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.fromFolder,
                accessor: 'fromFolder',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours) ? "todoList-grd-cell TODoGridCellBackgroundColor" : "todoList-grd-cell"}>
                            <span title={row.row?.original?.fromFolder}>{row.row?.original?.fromFolder}</span>
                        </div>
                    )
                },
                width: 200
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateInitiated,
                accessor: 'dateInitiated',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours) ? "todoList-grd-cell TODoGridCellBackgroundColor" : "todoList-grd-cell"}>
                            <span title={row.row?.original?.dateInitiated}>{row.row?.original?.dateInitiated}</span>
                        </div>
                    )
                },
                width: 220
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateAvailable,
                accessor: 'dateAvailable',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours) ? "todoList-grd-cell TODoGridCellBackgroundColor" : "todoList-grd-cell"}>
                            <span title={row.row?.original?.dateAvailable}>{row.row?.original?.dateAvailable}</span>
                        </div>
                    )
                },
                width: 220
            },
            
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateRedirected,
                accessor: 'dateRedirected',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours) ? "todoList-grd-cell TODoGridCellBackgroundColor" : "todoList-grd-cell"}>
                            <span title={row.row?.original?.dateRedirected}>{row.row?.original?.dateRedirected}</span>
                        </div>
                    )
                },
                width: 220
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.redirectReason,
                accessor: 'redirectReason',
                Cell: row => {
                    return (
                        <div className={CommonUtility.compareTimeDifferenceWithCurrent(row.row?.original?.dateAvailable, row.row?.original?.folderColorChangeTimeInHours) ? "todoList-grd-cell TODoGridCellBackgroundColor" : "todoList-grd-cell"}>
                            <span title={row.row?.original?.redirectReason}>{row.row?.original?.redirectReason}</span>
                        </div>
                    )
                },
                width: 214
            }
        ]
        return gridColumns;
    }

    public getRecylceBinGridColumns(handleDocumentRecycleBinClick: (id: any) => void) {
        let gridColumns = [
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.fileName,
                accessor: 'scanId',
                Cell: row => {
                    return (
                        <div className="todoList-grd-cell">
                            <Link
                                to={{
                                    pathname: '',
                                    state: { scanId: row.row?.original?.scanId, id: row.row?.original?.id, docStatus: row.row?.original?.isWorking ? 'working' : row.row?.original?.isHardLocked ? 'hardLocked' : row.row?.original?.canHardLock ? 'softLocked' : '' }
                                }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    handleDocumentRecycleBinClick(row.row?.original?.id)
                                }
                                }
                                className="text-start text-decoration-none scanIdStyle"
                                title="row.value"                                
                            ><span title={row.row?.original?.scanId}>{row.row?.original?.scanId}</span></Link>                            
                        </div>
                    )
                },
                width: 215,
                sortType: 'string'
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.docDescription,
                accessor: 'docDescription',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.docDescription}>{row.row?.original?.docDescription}</span>
                        </div>
                    )
                },
                width: 220
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.fromFolder,
                accessor: 'fromFolder',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.fromFolder}>{row.row?.original?.fromFolder}</span>
                        </div>
                    )
                },
                width: 175
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateInitiated,
                accessor: 'dateInitiated',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.dateInitiated}>{row.row?.original?.dateInitiated}</span>
                        </div>
                    )
                },
                width: 200
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateAvailable,
                accessor: 'dateAvailable',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.dateAvailable}>{row.row?.original?.dateAvailable}</span>
                        </div>
                    )
                },
                width: 200
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateRedirected,
                accessor: 'dateRedirected',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.dateRedirected}>{row.row?.original?.dateRedirected}</span>
                        </div>
                    )
                },
                width: 200
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateDeleted,
                accessor: 'dateDeleted',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.dateDeleted}>{row.row?.original?.dateDeleted}</span>
                        </div>
                    )
                },
                width: 200
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.deletedBy,
                accessor: 'deletedBy',
                Cell: row => {
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.deletedBy}>{row.row?.original?.deletedBy}</span>
                        </div>
                    )
                },
            width: 175
            },
            {
                Header: documateLabel.TODOLIST_GRID_LABELS.dateExpired,
                accessor: 'dateExpired',
                Cell: row => {
                    //let dateDeleted = new Date(row.row?.original?.dateDeleted);
                    //let dateExpired = new Date(dateDeleted);
                    //dateExpired.setDate(dateDeleted.getDate() + 180); 
                    //let formattedExpiredDate = CommonUtility.formateDateTime(row.row?.original?.dateExpired as any, CommonUtility.DateTimeFormatWithSecond)
                    return (
                        <div className='todoList-grd-cell'>
                            <span title={row.row?.original?.dateExpired}>{row.row?.original?.dateExpired}</span>
                    </div>
                    );
                },
                width: 200
            }
        ]
        return gridColumns;
    }

    getListOfGroupDocCountToDoList = async () => {

        var GroupDocData = await getListOfGroupDocCountToDoList();
        if (GroupDocData.length > 0) {
            const groupList = GroupDocData.map((item: GroupListDocCountResponseDto) =>
            ({
                label: item.groupName,
                value: item.groupId,
                count: item.documentCount.toString()
            }));
            return groupList;
        }

        return [];
    }

    getListOfGroupDocCountRecycleList = async () => {
        var GroupList = await getListOfGroup(false);
        const groupList = GroupList.map((item: DocQueueGroupListResponseDto) => 
            ({
                value: item.id,
                label: item.groupName
              }));
        
            return groupList;
            }

    getListOfFolderDocCountToDoList = async (groupId: string) => {

        var FolderDocData = await getListOfFolderDocCountToDoList(groupId);
        const folderList = FolderDocData.map((item: FolderListDocCountResponseDto) =>
        ({
            label: item.folderName,
            value: item.folderId,
            count: item.documentCount.toString()
        }));

        return folderList;
    }

    getListOfFolderDocCountRecycleList = async (groupId: string) => {
        const getFolderListByGroupIdRequestModel: GetFolderListByGroupIdQuery = {
            GroupId: groupId,
            screenName: "Indexing",// we need list of folder, same as coming on Indexing screen.
        }
        var FolderDocData = await getListOfFolderByGroupId(getFolderListByGroupIdRequestModel);
        const folderList = FolderDocData.map((item) =>
        ({
            label: item.folderName,
            value: item.id
        }));

        return folderList;
   }

    getUsersRecycleBin = async () => {
        var UsersData = await getUsersRecycleBin();
        var users = [{
            label: 'All',
            value: 'allUsers',
            status: 'active',
            isInactive: false
        }];

        UsersData.forEach(item => {
            var dataUser = {
                label: item.displayName ?? '',
                value: item.id,
                status: 'active',
                isInactive: false
            }

            users = [...users, dataUser];

        });

        return users;
    }

    getUsersToDoList = async (groupList: string[]) => {
        var UsersData = await getUsersToDoList(groupList);
        var users = [{
            label: docuMateConstant.TODO_LIST_UsersDropDown_All,
            value: docuMateConstant.TODO_LIST_UsersDropDown_AllValue,
            status: 'active',
            isInactive: false
        },
        {
            label: docuMateConstant.TODO_LIST_UsersDropDown_UnAssigned,
            value: docuMateConstant.TODO_LIST_UsersDropDown_UnAssignedId,
            status: 'active',
            isInactive: false
        }
        ];

        UsersData.forEach(item => {
            var dataUser = {
                label: item.displayName ?? '',
                value: item.id,
                status: 'active',
                isInactive: false
            }

            users = [...users, dataUser];
        });

        return users;
    }

    searchDocToDoList = async (groupId: string[], folderIds: string[], users: string[], isDeleted: boolean, lockedDocumentIds: string[] = []) => {

        var searchedDocData = await searchDocToDoList(groupId, folderIds, users, isDeleted);
        // GetMyLockedDocuments and SearchDocumentOnToDoList do not agree on GUID casing.
        const lockedByMe = new Set((lockedDocumentIds ?? []).map(id => id?.toString().toLowerCase()));
        let toDoList = [];
        if (searchedDocData != null && searchedDocData.length > 0) {
            toDoList = searchedDocData.map((item: GetDocumentInfoOnSearchResponseDto) =>
            ({
                id: item.id.toString(),
                scanId: item.scanId,
                onHold: (item.onHold != null) ? item.onHold : false,
                docDescription: item.docDescription,
                fromFolder: item.fromFolder,
                assignedTo: item.assignedTo,
                redirectReason: item.redirectReason,
                dateRedirected: item.dateRedirected,
                dateInitiated: item.dateQueued,
                dateAvailable: item.dateAvailable,
                isSoftLock: item.isSoftLock,
                isPickedForLock: lockedByMe.has(item.id?.toString().toLowerCase()),
                isHardLocked: item.isHardLocked,
                canHardLock: item.canHardLock,
                isWorking: item.isWorking,
                documentUserId: item.documentUserId,
                deletedBy: item.deletedBy,
                dateDeleted: item.dateDeleted,
                folderColorChangeTimeInHours: item.folderColorChangeTimeInHours,
                docFileId:item.docFileId,             
            }));
        }
        return toDoList;
    }

    // searchRecycleList = async (groupId: string, folderIds: string[], users: string[]) => {

    //     // var recycleDocData = await searchDocToDoList(groupId, folderIds, users);
    //     let recycleList = [];
    //     return recycleList;
    // }

    updateDocStatusToDoList = async (id: string, documentStatus: number, documentUserId: string): Promise<DocumentStatusResponseDto> => {

        var responseData = await updateDocStatusToDoList(id, documentStatus, documentUserId);
        return responseData;
    }

    toggleDocumentLock = async (documentId: string, markLock: boolean): Promise<LockDocumentsResponseDto> => {
        return await toggleDocumentLock(documentId, markLock);
    }

    getMyLockedDocuments = async (): Promise<string[]> => {
        return await getMyLockedDocuments();
    }

    hardLockDocument = async (documentId: string): Promise<LockDocumentsResponseDto> => {
        return await hardLockDocument(documentId);
    }

    releaseSoftLockDocuments = async (): Promise<LockDocumentsResponseDto> => {
        return await releaseSoftLockDocuments();
    }
}

export default DocuMateTodoListService;